import { z } from 'zod'

export const mailProviderSchema = z.enum(['GMAIL', 'OUTLOOK', 'IMAP'])
export const mailScopeSchema = z.enum(['WORKSPACE', 'USER'])
export const mailConnectionStatusSchema = z.enum(['ACTIVE', 'NEEDS_REAUTH'])

export type MailProvider = z.infer<typeof mailProviderSchema>
export type MailScope = z.infer<typeof mailScopeSchema>

export const mailConnectionSchema = z.object({
  id: z.string(),
  provider: mailProviderSchema,
  emailAddress: z.string(),
  scope: mailScopeSchema,
  status: mailConnectionStatusSchema,
  connectedByUserId: z.string(),
})
export type MailConnection = z.infer<typeof mailConnectionSchema>

export interface ImapConnectRequest {
  scope: MailScope
  emailAddress: string
  username: string
  password: string
  imapHost: string
  imapPort: number
  smtpHost: string
  smtpPort: number
}

export const mailProvidersSchema = z.object({ gmail: z.boolean(), outlook: z.boolean() })
export type MailProviders = z.infer<typeof mailProvidersSchema>

export const mailOAuthStartSchema = z.object({ authorizationUrl: z.string() })

/** The headers that identify one email and let a reply thread under it. */
export const mailMessageSchema = z.object({
  messageId: z.string(),
  threadId: z.string().nullish(),
  internetMessageId: z.string().nullish(),
  references: z.string().nullish(),
  subject: z.string().nullish(),
  from: z.string().nullish(),
  replyTo: z.string().nullish(),
  to: z.string().nullish(),
  cc: z.string().nullish(),
  date: z.string().nullish(),
  snippet: z.string().nullish(),
})
export type MailMessage = z.infer<typeof mailMessageSchema>

export const mailPageSchema = z.object({
  items: z.array(mailMessageSchema),
  nextPageToken: z.string().nullish(),
})
export type MailPage = z.infer<typeof mailPageSchema>
